import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { cn } from "@/lib/utils";
import { CalendarDays } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");
const toIso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const fromIso = (v) => {
  if (!v) return undefined;
  const [y, m, d] = String(v).slice(0, 10).split("-").map(Number);
  return y && m && d ? new Date(y, m - 1, d) : undefined;
};
const label = (v) => fromIso(v)?.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });

/** Shadcn date picker that reads/writes plain "YYYY-MM-DD" calendar dates. */
export default function DateInput({ value, onChange, min, max, placeholder = "Pick a date", className, testid }) {
  const [open, setOpen] = useState(false);
  const disabled = [min && { before: fromIso(min) }, max && { after: fromIso(max) }].filter(Boolean);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={cn("flex h-11 w-full items-center gap-2 rounded-md border border-input bg-background px-3 text-sm text-left transition-colors hover:border-teal/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal", !value && "text-slate-400", className)}>
          <CalendarDays className="h-4 w-4 text-slate-400 shrink-0" />
          <span className="truncate">{value ? label(value) : placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={testid ? `${testid}-popover` : undefined}>
        <Calendar mode="single" selected={fromIso(value)} defaultMonth={fromIso(value)} disabled={disabled} weekStartsOn={1}
          onSelect={(d) => { if (d) { onChange(toIso(d)); setOpen(false); } }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
